import { AppState } from 'web/store'
import { ExcelerateCareerPrepStateData } from './CareerPrep.reducer'

export const enableDate = () => (state: AppState): string => {
  const excelerateCareerPrepData: ExcelerateCareerPrepStateData | null =
    state.excelerate.careerPrep.data
  return (excelerateCareerPrepData && excelerateCareerPrepData.enableDate) || ''
}
